module.exports = __webpack_public_path__ + "static/media/starlla5.72a4a924.jpg";